<template>
	<div>
		<!-- 精品推荐模块左右集合 -->
		<div class="mainbox" style="overflow: hidden">
			<div class="main_left">
				<div class="main_img">
					<router-link
						:to="{
							path: '/list',
							query: { uid: 'A31039', type: '1' },
						}"
					>
						<img
							src="../assets/images/img_01.jpg"
							width="147"
							height="166"
							border="0"
					/></router-link>
					<div class="maintext">
						<h3
							style="
								padding-top: 32px;
								color: #000000;
								font-size: 20px;
							"
						>
							<router-link
								:to="{
									path: '/list',
									query: { uid: 'A31039', type: '1' },
								}"
								style="color: #000000"
							>
								关注“十四五”
							</router-link>
						</h3>
						<p>
							<router-link
								:to="{
									path: '/list',
									query: { uid: 'A31039', type: '1' },
								}"
								style="color: #fff"
							>
								数据库
							</router-link>
						</p>
						<div style="width: 120px; margin: 0 auto">
							<router-link
								:to="{
									path: '/list',
									query: { uid: 'A31039', type: '1' },
								}"
								class="f7 ff"
								title="本数据库重点收录反映中央精神、地方举措、重大项目进展的动态信息以及专家对“十四五”经济社会发展方面的分析研判、对策建议文章，力求全面、多角度的为客户展示 “十四五”规划的编制、执行以及政策效果、分析评价等内容，为各级政府、研究机构及企业单位提供决策支持和研究参考。
"
							>
								本数据库重点收录反映中央精神、地方举措、重大项目进展的动态信息以及专家对...
							</router-link>
						</div>
					</div>
				</div>
			</div>
			<div class="main_left" style="margin-left: 3px">
				<div class="main_img">
					<router-link
						:to="{
							path: '/list',
							query: { uid: '2244', type: '1' },
						}"
					>
						<img
							src="../assets/images/img_02.jpg"
							width="147"
							height="166"
							border="0"
					/></router-link>
					<div class="maintext">
						<h3
							style="
								padding-top: 32px;
								color: #000000;
								font-size: 20px;
							"
						>
							<router-link
								:to="{
									path: '/list',
									query: { uid: '2244', type: '1' },
								}"
								style="color: #000000"
								>中国式现代化</router-link
							>
						</h3>
						<p>
							<router-link
								:to="{
									path: '/list',
									query: { uid: '2244', type: '1' },
								}"
								style="color: #fff"
								>数据库</router-link
							>
						</p>
						<div style="width: 120px; margin: 0 auto">
							<router-link
								:to="{
									path: '/list',
									query: { uid: '2244', type: '1' },
								}"
								class="f7 ff"
								title="本数据库及时跟踪我国实现中国式现代化的建设进展，广泛收录全国各地在推进中国式现代化建设方面的前沿动态，以及权威机构和专家学者对于中国式现代化前瞻性观点和理论成果，从而为相关政策制定、实践操作、理论研究提供高价值的信息参考。"
								>本数据库及时跟踪我国实现中国式现代化的建设进展，广泛收录全国各地在推进中国...</router-link
							>
						</div>
					</div>
				</div>
			</div>
			<div class="main_left" style="margin-left: 3px">
				<div class="main_img">
					<router-link
						:to="{
							path: '/list',
							query: { uid: '2243', type: '1' },
						}"
					>
						<img
							src="../assets/images/img_03.jpg"
							width="147"
							height="166"
							border="0"
					/></router-link>
					<div class="maintext" style="margin-top: 0">
						<h3
							style="
								padding-top: 32px;
								color: #000000;
								font-size: 20px;
							"
						>
							<router-link
								:to="{
									path: '/list',
									query: { uid: '2243', type: '1' },
								}"
								style="color: #000000"
								>共同富裕</router-link
							>
						</h3>
						<p>
							<router-link
								:to="{
									path: '/list',
									query: { uid: '2243', type: '1' },
								}"
								style="color: #fff"
								>数据库</router-link
							>
						</p>
						<div style="width: 120px; margin: 0 auto">
							<router-link
								:to="{
									path: '/list',
									query: { uid: '2243', type: '1' },
								}"
								class="f7 ff"
								title="本数据库跟踪我国扎实推进全体人民共同富裕的实施进展，收录各地区推进共同富裕的实际举措和阶段性成果，汇聚专家学者关于实现共同富裕的趋势分析、政策讨论、理论探究等方面的文献资料，以及中央及各地政府出台的有关共同富裕的政策举措和实施方案，从而为相关政策制定、实践操作和理论研究提供信息参考。"
								>本数据库跟踪我国扎实推进全体人民共同富裕的实施进展，收录各地区推进共同富裕的...</router-link
							>
						</div>
					</div>
				</div>
			</div>
			<div class="main_left" style="margin-left: 3px">
				<div class="main_img">
					<router-link
						:to="{
							path: '/list',
							query: { uid: 'A31046', type: '1' },
						}"
					>
						<img
							src="../assets/images/img_04.jpg"
							width="147"
							height="166"
							border="0"
					/></router-link>
					<div class="maintext">
						<h3
							style="
								padding-top: 32px;
								color: #000000;
								font-size: 20px;
							"
						>
							<router-link
								:to="{
									path: '/list',
									query: { uid: 'A31046', type: '1' },
								}"
								style="color: #000000"
								>新质生产力</router-link
							>
						</h3>
						<p>
							<router-link
								:to="{
									path: '/list',
									query: { uid: 'A31046', type: '1' },
								}"
								style="color: #fff"
								>数据库</router-link
							>
						</p>
						<div style="width: 120px; margin: 0 auto">
							<router-link
								:to="{
									path: '/list',
									query: { uid: 'A31046', type: '1' },
								}"
								class="f7 ff overflow-3-hidden"
								title="本数据库全面、及时收录关于发展新质生产力的具体举措和阶段性成果的；汇集知名专家学者关于发展新质生产力的观点分析与评论"
								>本数据库全面、及时收录关于发展新质生产力的具体举措和阶段性成果的；汇集知名专家学者关于发展新质生产力的观点分析与评论</router-link
							>
						</div>
					</div>
				</div>
			</div>
			<div class="main_right" style="width: 460px">
				<div class="cbox">
					<h2>
						<router-link
							v-if="recommend.text"
							:to="{
								path: '/list',
								query: { uid: recommend.uid, type: '1' },
							}"
							style="color: #b71515"
						>
							{{ recommend.text }}
						</router-link>
						<el-skeleton
							v-else
							:rows="1"
							animated
							style="margin-top: 0"
						/>
						<span class="morebox">
							<router-link
								:to="{
									path: '/list',
									query: { uid: recommend.uid, type: '1' },
								}"
								class="cbox_font"
								>更多+</router-link
							>
						</span>
					</h2>
				</div>
				<img
					src="../assets/images/line_title.png"
					style="display: block; margin-top: 4px"
				/>
				<ul id="ContentPlaceHolder1_jptj" v-if="recommendList.length">
					<div
						class="main_content"
						v-for="(item, index) in recommendList"
						:key="index"
					>
						<a
							name="subject"
							:href="
								$ArticleUrl +
								'?chnid=' +
								item.chnid +
								'&leafid=' +
								item.leafid +
								'&docid=' +
								item.code.substring(4, item.code.length) +
								'&uid=' +
								recommend.uid +
								'&version=gov'
							"
							:title="item.title"
							style="color: black"
							target="_blank"
						>
							<h3 class="c2 overflow-one-rows-rule">
								{{ item.title }}
							</h3></a
						><a
							target="_blank"
							:href="
								$ArticleUrl +
								'?chnid=' +
								item.chnid +
								'&leafid=' +
								item.leafid +
								'&docid=' +
								item.code.substring(4, item.code.length) +
								'&uid=' +
								recommend.uid +
								'&version=gov'
							"
							class="f7"
							><div>
								<span name="summary"
									>{{ item.summary.slice(0, 85) }}
									<span v-if="item.summary.length > 80">
										...
										<a
											:href="
												$ArticleUrl +
												'?chnid=' +
												item.chnid +
												'&leafid=' +
												item.leafid +
												'&docid=' +
												item.code.substring(
													4,
													item.code.length
												) +
												'&uid=' +
												recommend.uid +
												'&version=gov'
											"
											target="_blank"
											style="color: #f00; cursor: pointer"
											>【详情】</a
										></span
									>
								</span>
							</div></a
						>
					</div>
				</ul>
				<!-- <list
          v-if="recommendList.length"
          type="titleSummary"
          :listData="recommendList"
          width="460"
          imgWidth=""
          imgHeight=""
          firstTitleFontSize=""
          firstTitleColor=""
          firstTitleLineHeight=""
          titleFontSize="17px"
          titleColor="#333"
          titleLineHeight="20px"
          dateFontSize="14px"
          dateColor="#999"
          summaryFontSize="14px"
          summaryColor="#333"
          summaryLineHeight="18px"
          interceptWord="83"
          titleMargin="0 0 6px 0"
          fontWeight="600"
        /> -->
				<template v-else>
					<el-skeleton :rows="3" animated style="margin-top: 24px" />
					<el-skeleton :rows="3" animated style="margin-top: 18px" />
					<el-skeleton :rows="3" animated style="margin-top: 24px" />
				</template>
			</div>
		</div>
		<!-- 领导讲话-全球经济-宏观监测-区域发展  左侧结构&&右侧结构   -->
		<div class="content_b" style="overflow: hidden">
			<div class="content2" style="float: left">
				<template v-if="columnItemData.length">
					<ListItem
						v-for="(item, index) in columnItemData"
						:key="index"
						:item="item"
					/>
				</template>
				<!-- 骨架屏  -->
				<div class="m-skeleton-store" style="margin-top: 20px" v-else>
					<template>
						<div class="skeleton-store-style">
							<div
								style="
									width: 340px;
									position: relative;
									display: flex;
									flex-direction: row;
								"
							>
								<el-skeleton-item
									variant="image"
									style="width: 157px; height: 97px"
								/>
								<div
									style="
										width: calc(100% - 157px);
										margin-left: 0px;
									"
								>
									<el-skeleton-item
										:animated="true"
										:rows="3"
										variant="text"
										style="
											margin-left: 20px;
											margin-top: 16px;
										"
									/>
									<el-skeleton-item
										:animated="true"
										:rows="3"
										variant="text"
										style="
											margin-left: 20px;
											margin-top: 16px;
										"
									/>
									<el-skeleton-item
										:animated="true"
										:rows="3"
										variant="text"
										style="
											margin-left: 20px;
											margin-top: 8px;
										"
									/>
								</div>
							</div>
							<el-skeleton
								style="width: 340px; margin-top: 18px"
								:rows="4"
								animated
							/>
						</div>
					</template>
					<template>
						<div class="skeleton-store-style">
							<div
								style="
									width: 340px;
									position: relative;
									display: flex;
									flex-direction: row;
								"
							>
								<el-skeleton-item
									variant="image"
									style="width: 157px; height: 97px"
								/>
								<div
									style="
										width: calc(100% - 157px);
										margin-left: 0px;
									"
								>
									<el-skeleton-item
										:animated="true"
										:rows="3"
										variant="text"
										style="
											margin-left: 20px;
											margin-top: 16px;
										"
									/>
									<el-skeleton-item
										:animated="true"
										:rows="3"
										variant="text"
										style="
											margin-left: 20px;
											margin-top: 16px;
										"
									/>
									<el-skeleton-item
										:animated="true"
										:rows="3"
										variant="text"
										style="
											margin-left: 20px;
											margin-top: 8px;
										"
									/>
								</div>
							</div>
							<el-skeleton
								style="width: 340px; margin-top: 18px"
								:rows="4"
								animated
							/>
						</div>
					</template>
					<template>
						<div class="skeleton-store-style">
							<div
								style="
									width: 340px;
									position: relative;
									display: flex;
									flex-direction: row;
								"
							>
								<el-skeleton-item
									variant="image"
									style="width: 157px; height: 97px"
								/>
								<div
									style="
										width: calc(100% - 157px);
										margin-left: 0px;
									"
								>
									<el-skeleton-item
										:animated="true"
										:rows="3"
										variant="text"
										style="
											margin-left: 20px;
											margin-top: 16px;
										"
									/>
									<el-skeleton-item
										:animated="true"
										:rows="3"
										variant="text"
										style="
											margin-left: 20px;
											margin-top: 16px;
										"
									/>
									<el-skeleton-item
										:animated="true"
										:rows="3"
										variant="text"
										style="
											margin-left: 20px;
											margin-top: 8px;
										"
									/>
								</div>
							</div>
							<el-skeleton
								style="width: 340px; margin-top: 18px"
								:rows="4"
								animated
							/>
						</div>
					</template>
					<template>
						<div class="skeleton-store-style">
							<div
								style="
									width: 340px;
									position: relative;
									display: flex;
									flex-direction: row;
								"
							>
								<el-skeleton-item
									variant="image"
									style="width: 157px; height: 97px"
								/>
								<div
									style="
										width: calc(100% - 157px);
										margin-left: 0px;
									"
								>
									<el-skeleton-item
										:animated="true"
										:rows="3"
										variant="text"
										style="
											margin-left: 20px;
											margin-top: 16px;
										"
									/>
									<el-skeleton-item
										:animated="true"
										:rows="3"
										variant="text"
										style="
											margin-left: 20px;
											margin-top: 16px;
										"
									/>
									<el-skeleton-item
										:animated="true"
										:rows="3"
										variant="text"
										style="
											margin-left: 20px;
											margin-top: 8px;
										"
									/>
								</div>
							</div>
							<el-skeleton
								style="width: 340px; margin-top: 18px"
								:rows="4"
								animated
							/>
						</div>
					</template>
					<template>
						<div class="skeleton-store-style">
							<div
								style="
									width: 340px;
									position: relative;
									display: flex;
									flex-direction: row;
								"
							>
								<el-skeleton-item
									variant="image"
									style="width: 157px; height: 97px"
								/>
								<div
									style="
										width: calc(100% - 157px);
										margin-left: 0px;
									"
								>
									<el-skeleton-item
										:animated="true"
										:rows="3"
										variant="text"
										style="
											margin-left: 20px;
											margin-top: 16px;
										"
									/>
									<el-skeleton-item
										:animated="true"
										:rows="3"
										variant="text"
										style="
											margin-left: 20px;
											margin-top: 16px;
										"
									/>
									<el-skeleton-item
										:animated="true"
										:rows="3"
										variant="text"
										style="
											margin-left: 20px;
											margin-top: 8px;
										"
									/>
								</div>
							</div>
							<el-skeleton
								style="width: 340px; margin-top: 18px"
								:rows="4"
								animated
							/>
						</div>
					</template>
					<template>
						<div class="skeleton-store-style">
							<div
								style="
									width: 340px;
									position: relative;
									display: flex;
									flex-direction: row;
								"
							>
								<el-skeleton-item
									variant="image"
									style="width: 157px; height: 97px"
								/>
								<div
									style="
										width: calc(100% - 157px);
										margin-left: 0px;
									"
								>
									<el-skeleton-item
										:animated="true"
										:rows="3"
										variant="text"
										style="
											margin-left: 20px;
											margin-top: 16px;
										"
									/>
									<el-skeleton-item
										:animated="true"
										:rows="3"
										variant="text"
										style="
											margin-left: 20px;
											margin-top: 16px;
										"
									/>
									<el-skeleton-item
										:animated="true"
										:rows="3"
										variant="text"
										style="
											margin-left: 20px;
											margin-top: 8px;
										"
									/>
								</div>
							</div>
							<el-skeleton
								style="width: 340px; margin-top: 18px"
								:rows="4"
								animated
							/>
						</div>
					</template>
				</div>
			</div>
			<div class="content2_right" style="border: none">
				<div class="content2box" style="padding-top: 20px">
					<div class="content2box">
						<template>
							<router-link
								:to="{ path: '/NPCandCPPCC' }"
								class="btn_blue b1"
								style="background-color: #0082ad"
							>
								<img
									src="./images/img.png"
									width="30"
									height="32"
								/>特供两会专题</router-link
							>
							<router-link
								class="btn_blue b1"
								:to="{
									path: '/list',
									query: { uid: '24963', type: '1' },
								}"
								target="_blank"
							>
								<img
									src="./images/icon_book.png"
									width="30"
									height="32"
								/>
								信息精选季刊
							</router-link>
						</template>
						<a
							href="http://misc.drcnet.com.cn/Personalized/PersonalizedService.aspx"
							class="btn_blue b2"
							target="_blank"
						>
							<img
								src="./images/icon_red.png"
								width="30"
								height="32"
							/>个性化服务</a
						>
					</div>

					<div class="content2box">
						<div class="content2_right_title">
							<img
								src="./images/content2_right_title2.png"
								width="340"
								height="17"
							/><a
								href="https://www.drcnet.com.cn/www/TrainInterview/"
								style="
									position: absolute;
									top: 4px;
									right: 24px;
									font-size: 12px;
									color: #000;
								"
								>更多</a
							>
						</div>
						<div
							style="
								border: 1px solid #dcdcdc;
								border-top: none;
								overflow: hidden;
								padding-top: 6px;
							"
							id="divTrain"
						>
							<div
								v-for="(item, index) in expertStoreData"
								:key="index"
								style="
									border-bottom: 1px dashed #dcdcdc;
									overflow: hidden;
								"
							>
								<div
									class="nxbox"
									style="
										width: 76px;
										height: 109px;
										float: left;
									"
								>
									<a
										:href="
											'http://expert.drcnet.com.cn/#/expert?name=' +
											item.expertname
										"
										target="_blank"
										><img
											:src="
												'http://expert.drcnet.com.cn/expert/file/image/' +
												item.expertname
											"
											width="76"
											height="109"
											class="nx"
									/></a>
								</div>
								<div class="name_nx" style="float: right">
									<h3>{{ item.expertname }}</h3>
									<a
										:href="
											'http://www.drcnet.com.cn/www/TrainInterview/TrainInterviewDetail.aspx?interviewid=' +
											item.docId
										"
										target="_blank"
										class="f26 expert-summary-style"
										>{{ item.summary }}</a
									>
								</div>
							</div>
						</div>
					</div>

					<div class="content2box" style="padding-bottom: 10px">
						<a
							target="_blank"
							href="https://www.drcnet.com.cn/specialSubject"
						>
							<div class="content2_right_title">
								<img src="./images/content2_right_title3.png" />
							</div>
						</a>
						<div
							style="
								border: 1px solid #dcdcdc;
								border-top: none;
								padding-top: 14px;
							"
							class="hot-news"
						>
							<div></div>
							<div style="clear: both"></div>
							<ul
								class="hotdot"
								style="padding: 8px 0 9px 15px; overflow: auto"
							>
								<li
									class="mj_gray overflow-rule"
									v-for="(item, index) in hotTopicsData"
									:key="index"
								>
									<a
										class="f20"
										:href="
											item.url == ''
												? `https://zhuanti.drcnet.com.cn/detailindex${item.templatetype}home?chnid=${item.chnId}`
												: item.url
										"
										target="_blank"
										:title="item.chnName"
									>
										{{ item.chnName }}
									</a>
								</li>
							</ul>
						</div>
					</div>

					<div style="clear: both"></div>
				</div>
			</div>
			<div class="celibratebox">
				<div class="celebrate">
					<!-- http://theme.drcnet.com.cn -->
					<a :href="governmentSubData.url" target="_blank">
						<!-- 下行站位 -->
						<img
							src="./images/subjectspecialxjp1.png"
							width="1100"
							height="0"
							border="0"
						/>
						<!-- 上行站位 -->

						<div class="middle-subject-space">
							{{ governmentSubData.chnName }}
						</div>
					</a>
				</div>
			</div>
		</div>
		<div class="content_b" style="overflow: hidden">
			<template v-if="bottomColumnItemData.length">
				<ListItem
					v-for="(item, index) in bottomColumnItemData"
					:key="index"
					:item="item"
					class="bottom-column-item"
				/>
			</template>
			<!-- 骨架屏 -->
			<div style="margin-top: 20px" v-else>
				<template>
					<div class="bottom-skeleton-store-style">
						<div
							style="
								width: 340px;
								position: relative;
								display: flex;
								flex-direction: row;
							"
						>
							<el-skeleton-item
								variant="image"
								style="width: 157px; height: 97px"
							/>
							<div
								style="
									width: calc(100% - 157px);
									margin-left: 0px;
								"
							>
								<el-skeleton-item
									:animated="true"
									:rows="3"
									variant="text"
									style="margin-left: 20px; margin-top: 16px"
								/>
								<el-skeleton-item
									:animated="true"
									:rows="3"
									variant="text"
									style="margin-left: 20px; margin-top: 16px"
								/>
								<el-skeleton-item
									:animated="true"
									:rows="3"
									variant="text"
									style="margin-left: 20px; margin-top: 8px"
								/>
							</div>
						</div>
						<el-skeleton
							style="width: 340px; margin-top: 18px"
							:rows="4"
							animated
						/>
					</div>
				</template>
				<template>
					<div class="bottom-skeleton-store-style">
						<div
							style="
								width: 340px;
								position: relative;
								display: flex;
								flex-direction: row;
							"
						>
							<el-skeleton-item
								variant="image"
								style="width: 157px; height: 97px"
							/>
							<div
								style="
									width: calc(100% - 157px);
									margin-left: 0px;
								"
							>
								<el-skeleton-item
									:animated="true"
									:rows="3"
									variant="text"
									style="margin-left: 20px; margin-top: 16px"
								/>
								<el-skeleton-item
									:animated="true"
									:rows="3"
									variant="text"
									style="margin-left: 20px; margin-top: 16px"
								/>
								<el-skeleton-item
									:animated="true"
									:rows="3"
									variant="text"
									style="margin-left: 20px; margin-top: 8px"
								/>
							</div>
						</div>
						<el-skeleton
							style="width: 340px; margin-top: 18px"
							:rows="4"
							animated
						/>
					</div>
				</template>
				<template>
					<div class="bottom-skeleton-store-style">
						<div
							style="
								width: 340px;
								position: relative;
								display: flex;
								flex-direction: row;
							"
						>
							<el-skeleton-item
								variant="image"
								style="width: 157px; height: 97px"
							/>
							<div
								style="
									width: calc(100% - 157px);
									margin-left: 0px;
								"
							>
								<el-skeleton-item
									:animated="true"
									:rows="3"
									variant="text"
									style="margin-left: 20px; margin-top: 16px"
								/>
								<el-skeleton-item
									:animated="true"
									:rows="3"
									variant="text"
									style="margin-left: 20px; margin-top: 16px"
								/>
								<el-skeleton-item
									:animated="true"
									:rows="3"
									variant="text"
									style="margin-left: 20px; margin-top: 8px"
								/>
							</div>
						</div>
						<el-skeleton
							style="width: 340px; margin-top: 18px"
							:rows="4"
							animated
						/>
					</div>
				</template>
				<template>
					<div class="bottom-skeleton-store-style">
						<div
							style="
								width: 340px;
								position: relative;
								display: flex;
								flex-direction: row;
							"
						>
							<el-skeleton-item
								variant="image"
								style="width: 157px; height: 97px"
							/>
							<div
								style="
									width: calc(100% - 157px);
									margin-left: 0px;
								"
							>
								<el-skeleton-item
									:animated="true"
									:rows="3"
									variant="text"
									style="margin-left: 20px; margin-top: 16px"
								/>
								<el-skeleton-item
									:animated="true"
									:rows="3"
									variant="text"
									style="margin-left: 20px; margin-top: 16px"
								/>
								<el-skeleton-item
									:animated="true"
									:rows="3"
									variant="text"
									style="margin-left: 20px; margin-top: 8px"
								/>
							</div>
						</div>
						<el-skeleton
							style="width: 340px; margin-top: 18px"
							:rows="4"
							animated
						/>
					</div>
				</template>
				<template>
					<div class="bottom-skeleton-store-style">
						<div
							style="
								width: 340px;
								position: relative;
								display: flex;
								flex-direction: row;
							"
						>
							<el-skeleton-item
								variant="image"
								style="width: 157px; height: 97px"
							/>
							<div
								style="
									width: calc(100% - 157px);
									margin-left: 0px;
								"
							>
								<el-skeleton-item
									:animated="true"
									:rows="3"
									variant="text"
									style="margin-left: 20px; margin-top: 16px"
								/>
								<el-skeleton-item
									:animated="true"
									:rows="3"
									variant="text"
									style="margin-left: 20px; margin-top: 16px"
								/>
								<el-skeleton-item
									:animated="true"
									:rows="3"
									variant="text"
									style="margin-left: 20px; margin-top: 8px"
								/>
							</div>
						</div>
						<el-skeleton
							style="width: 340px; margin-top: 18px"
							:rows="4"
							animated
						/>
					</div>
				</template>
				<template>
					<div class="bottom-skeleton-store-style">
						<div
							style="
								width: 340px;
								position: relative;
								display: flex;
								flex-direction: row;
							"
						>
							<el-skeleton-item
								variant="image"
								style="width: 157px; height: 97px"
							/>
							<div
								style="
									width: calc(100% - 157px);
									margin-left: 0px;
								"
							>
								<el-skeleton-item
									:animated="true"
									:rows="3"
									variant="text"
									style="margin-left: 20px; margin-top: 16px"
								/>
								<el-skeleton-item
									:animated="true"
									:rows="3"
									variant="text"
									style="margin-left: 20px; margin-top: 16px"
								/>
								<el-skeleton-item
									:animated="true"
									:rows="3"
									variant="text"
									style="margin-left: 20px; margin-top: 8px"
								/>
							</div>
						</div>
						<el-skeleton
							style="width: 340px; margin-top: 18px"
							:rows="4"
							animated
						/>
					</div>
				</template>
			</div>
		</div>
		<div class="izl-rmenu" style="margin-left: 550px" id="adright">
			<a href="http://report.drcnet.com.cn/" target="_blank">
				<div class="btn btntext3">
					<span>国研网系列研究报告平台</span>
				</div>
			</a>
			<a href="http://caselib.drcnet.com.cn/" target="_blank">
				<div class="btn btntext1">
					<span>经济·管理案例库平台</span>
				</div>
			</a>
			<a href="http://emerging.drcnet.com.cn/" target="_blank">
				<div class="btn btntext2">
					<span>战略性新兴产业及未来产业数据库平台</span>
				</div>
			</a>
			<!--<a href="http://www.drcnet.com.cn/www/ecommerce/"  target='_blank'>
    <div class="btn btntext3">
      <span>电子商务数据库</span>
    </div>
  </a>-->
			<a href="http://mct.drcnet.com.cn" target="_blank">
				<div class="btn btntext4">
					<span>文旅产业融合发展信息平台</span>
				</div>
			</a>
			<a href="https://ydyl.drcnet.com.cn" target="_blank">
				<div class="btn btntext5">
					<span>国研网“一带一路”研究与决策平台</span>
				</div>
			</a>
			<!--<a href="http://worldminal.drcnet.com.cn/www/mineral/"  target='_blank'>
    <div class="btn btntext6">
      <span>全球矿产资源信息平台</span>
    </div>
  </a>-->
			<!--<a href="http://znzz.drcnet.com.cn/"  target='_blank'>
    <div class="btn btntext6">
      <span>智能制造战略支撑平台</span>
    </div>
  </a>-->
			<a href="http://szjj.drcnet.com.cn/" target="_blank">
				<div class="btn btntext8">
					<span>国研网数字经济发展观察与监测平台</span>
				</div>
			</a>
			<a href="http://policy.drcnet.com.cn/home/" target="_blank">
				<div class="btn btntext6">
					<span>政策法规库平台</span>
				</div>
			</a>
			<!--<div class="btn btntext8">关闭</div>-->
		</div>
	</div>
</template>

<script>
import List from '@/components/List.vue';
import {
	getDocList,
	getHotTopics,
	getExpertStore,
	getTopicListByUid,
} from '../require/api.js';
import ListItem from '../components/ListItem/index.vue';
import '../assets/mCss/home.css';
export default {
	name: 'Home',
	components: {
		List,
		ListItem,
	},
	data() {
		return {
			// 精品推荐数据
			recommend: {},
			recommendList: [],
			// 首页栏目Uid字符串合集
			// 2201,18,19,20,2210,2203,2233,2241,2230,2224,2206,2209
			columnItemUidString: 'A31001,A302,A303,A304,A31010,A31003',
			// 存放栏目数据
			columnItemData: [],
			bottomColumnItemUidString:
				'A31033,A31041,A31030,A31047,A31006,A31009',
			bottomColumnItemData: [],
			// 热点专题数据
			hotTopicsData: [],
			datas: [
				{
					title: '',
					summary: '',
				},
			],
			// 专家库
			expertStoreData: [],
			// 中间横幅党建专题数据<标题>
			governmentSubData: '',
		};
	},
	created() {
		this.getListForDataBaseShow();
		this.getColumnItemData();
		this.getBottomColumnItemData();
		this.getHotTopicsData();
		this.getExpertStoreData();
		this.getNewHotPoint();
	},
	methods: {
		// 获取精品推荐首页文章列表
		async getListForDataBaseShow() {
			const {
				data: { data },
			} = await getDocList({
				uid: 'A316',
				// curpage: "1",
				// pagesize: "3",
				// isdefault: "false",
				// webChannelTypeId: "1",
				// homePage: true,
			});
			if (data[0].docList.length) {
				this.recommend = data[0];
				this.recommendList = data[0].docList.splice(0, 3);
			}
			// LogCollection.send(0);
		},
		async getListItemData() {
			const param = {
				uid: '',
				// curpage: "1",
				// pagesize: "4",
				// isdefault: "false",
				// webChannelTypeId: "1",
				// homePage: true,
			};
			const data = await getDocList(param);
			if (data) {
				// console.log(data);
			}
		},
		// 获取模块数据
		async getColumnItemData() {
			const param = {
				uid: this.columnItemUidString,
				// curpage: "1",
				// pagesize: "4",
				// isdefault: false,
				// webChannelTypeId: "1",
				// homePage: true,
			};
			const {
				data: { data },
			} = await getDocList(param);
			if (data) {
				this.columnItemData = data;
			}
			LogCollection.send(0);
		},
		// 获取最下方的六个模块的数据
		async getBottomColumnItemData() {
			const param = {
				uid: this.bottomColumnItemUidString,
				// curpage: "1",
				// pagesize: "4",
				// isdefault: false,
				// webChannelTypeId: "1",
				// homePage: true,
			};
			const {
				data: { data },
			} = await getDocList(param);
			if (data) {
				this.bottomColumnItemData = data;
			}
		},
		// 获取去热点专题
		async getHotTopicsData() {
			const data = await getHotTopics({ topNum: 7 });
			if (data) {
				this.hotTopicsData = data.data.data;
			}
		},
		// 获取专家库数据
		async getExpertStoreData() {
			const {
				data: { data },
			} = await getExpertStore({ curpage: '1', pagesize: '3' });
			if (data.code == 0) {
				this.expertStoreData = data.data.data;
			}
		},
		// 获取去热点专题最新一条
		async getNewHotPoint() {
			const params = {
				uid: 'A1020401',
				curpage: 1,
				pagesize: 1,
			};
			const { data } = await getTopicListByUid(params);
			if (data.code == 0) {
				this.governmentSubData = data.data.data[0];
			}
		},
	},
};
</script>

<style lang="less" scoped>
.expert-summary-style {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}
.mainbox {
	width: 1101px;
	margin: 0 auto;
	margin-top: 40px;
	.main_left {
		width: 147px;
		height: 351px;
		float: left;
		h3 {
			text-align: center;
		}
		p {
			text-align: center;
			background-color: #d1221a;
			font-size: 13px;
			line-height: 19px;
			width: 55px;
			color: #fff;
			margin: 5px 44px 8px 44px;
		}
		a {
			text-align: center;
			img {
				border: 0;
				vertical-align: middle;
				display: inline-block;
			}
		}
		.maintext {
			background-color: #efeff1;
			height: 190px;
			.f7 {
				font-family: '宋体';
				font-size: 12px;
				color: #333;
				line-height: 18px;
			}
		}
	}
	.main_right {
		float: right;
		.cbox {
			position: relative;
			h2 {
				font-size: 19px;
				font-family: '微软雅黑';
				color: #ac0002;
				font-weight: bold;
			}
			.morebox {
				position: absolute;
				top: 0;
				right: 5px;
				.cbox_font {
					color: #454545;
					font-size: 12px;
					font-family: '宋体';
				}
			}
		}
		#ContentPlaceHolder1_jptj {
			.main_content {
				border-bottom: dashed 1px #666666;
				padding-bottom: 16px;
				.c2 {
					margin-top: 15px;
					margin-bottom: 6px;
					font-size: 17px;
					font-family: '微软雅黑';
				}
				.f7 {
					font-family: '宋体';
					font-size: 12px;
					color: #333;
					line-height: 18px;
				}
			}
		}
	}
}

.content_b {
	width: 1101px;
	margin: 0 auto;
	.content2 {
		width: 720px;
		overflow: hidden;
		.content2_box {
			margin-top: 20px;
			&:nth-child(even) {
				margin-left: 40px;
				// float: right;
			}
			.content2_title {
				background: url(./images/icon_shu.png) no-repeat center left;
				border-bottom: 2px solid #e5e5e5;
				padding: 8px 0;
				.f21 {
					color: #b71515;
					font-size: 20px;
					font-family: '微软雅黑';
					margin-left: 12px;
					font-weight: bold;
				}
				.f22 {
					color: #015293;
					font-size: 14px;
					font-family: '微软雅黑';
					margin-left: 36px;
					cursor: pointer;
				}
				.f23 {
					color: #333333;
					font-size: 12px;
					font-family: '微软雅黑';
					position: absolute;
					top: 14px;
					right: 0;
				}
				.f8 {
					margin: 0;
				}
			}
			.content2_pic {
				float: left;
				.content2_smalltitle {
					width: 160px;
					h4 {
						padding-top: 4px;
						font-family: '微软雅黑';
						font-size: 17px;
						color: #030303;
						padding-bottom: 4px;
						line-height: 22px;
					}
					.f6 {
						padding-top: 12px;
						/* line-height: 14px; */
					}
					.f7 {
						font-family: '宋体';
						font-size: 12px;
						color: #333;
						line-height: 18px;
					}
				}
			}
			.content2_smalltext {
				li {
					padding: 4px 0;
					line-height: 18px;
					.f15 {
						color: #333333;
						font-family: '微软雅黑';
						font-size: 14px;
						/* float: left; */
						display: inline;
					}
					.rgt {
						font-family: '微软雅黑';
						float: right;
						display: inline;
						font-size: 13px;
						color: #333333;
					}
				}
			}
		}
	}
	.celibratebox {
		width: 1101px;
		margin: 0 auto;
		.celebrate {
			padding-top: 14px;
			padding-bottom: 6px;
		}
	}
}

.content2_right {
	width: 298px;
	float: right;
	.content2box {
		width: 340px;
		padding-bottom: 5px;
		float: right;
		.hot-news {
			.hotdot {
				width: 100%;
				.mj_gray {
					width: 100%;
					box-sizing: border-box;
					text-align: left;
					a {
						display: inline-block;
						width: 90%;
						overflow: hidden; //超出的文本隐藏
						text-overflow: ellipsis; //溢出用省略号显示
						white-space: nowrap; // 默认不换行；
					}
				}
			}
		}
		.btn_blue {
			display: inline-block;
			color: #fff;
			cursor: pointer;
			width: 340px;
			line-height: 53px;
			font-size: 20px;
			margin-top: 2px;
			text-align: center;
			img {
				margin-right: 12px;
				margin-bottom: 4px;
				vertical-align: middle;
				display: inline-block;
			}
		}
		.b1 {
			background-color: #1e547b;
			letter-spacing: 1px;
		}
		.b2 {
			background-color: #c83030;
			letter-spacing: 5.2px;
		}
		.content2_right_title {
			position: relative;
			height: 18px;
			top: 17px;
			padding-bottom: 18px;
			margin-bottom: 10px;
		}

		.nx {
			padding: 12px 0 12px 12px;
		}
		.name_nx {
			width: 250px;
			float: right;
			margin-right: 6px;
			h3 {
				color: #cc0000;
				font-size: 15px;
				font-family: '微软雅黑';
				padding: 26px 0px 4px 0px;
				line-height: 22px;
			}
			.f26 {
				color: #666666;
				font-size: 14px;
				font-family: '微软雅黑';
				line-height: 18px;
			}
		}
		.hotdot {
			li {
				height: 34px;
				.f20 {
					font-size: 14px;
					color: #333333;
					font-family: '微软雅黑';
				}
				a {
					line-height: 34px;
					margin-left: 25px;
				}
				&:hover {
					background: url(./images/redshu.png) no-repeat center left;
					background-color: #f7f7f7;
				}
			}
			.mj_gray {
				border-bottom: 1px dashed #dcdcdc;
				background: url(./images/grayshu.png) no-repeat left center;
			}
		}
	}
}

.skeleton-store-style:nth-child(2n) {
	float: right;
	margin-bottom: 45px;
}
.skeleton-store-style:nth-child(odd) {
	float: left;
	margin-bottom: 45px;
}

.bottom-column-item:nth-child(3n-1) {
	margin-left: 35px;
	margin-right: 35px;
}

.bottom-skeleton-store-style {
	float: left;
	margin-bottom: 40px;
	&:nth-child(3n-1) {
		margin: 0 35px;
	}
}

.overflow-rule {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
}
.overflow-one-rows-rule {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	line-height: 120%;
}
// 飘窗
.izl-rmenu {
	position: fixed;
	left: 50%;
	margin-left: 532px;
	bottom: 10px;
	padding-bottom: 73px;
	z-index: 999;
	.btntext3 {
		background-color: #6cafeb;
		&:hover {
			background-color: #5d9fdb;
		}
		span {
			padding-top: 15px !important;
		}
	}
	.btntext1 {
		background-color: #78c340;
		&:hover {
			background-color: #58a81c;
		}
		span {
			padding-top: 17px !important;
		}
	}
	.btntext2 {
		background-color: #fbb01f;
		&:hover {
			background-color: #ff811b;
		}
		span {
			padding-top: 8px !important;
		}
	}
	.btntext4 {
		background-color: #e37677;
		&:hover {
			background-color: #dd6364;
		}
		span {
			padding-top: 15px !important;
		}
	}
	.btntext5 {
		background-color: #666666;
		height: 80px;
		&:hover {
			background-color: #444;
		}
		span {
			padding-top: 7px !important;
		}
	}
	.btntext8 {
		background-color: #30aebd;
		&:hover {
			background-color: #209dac;
		}
		span {
			padding-top: 7px !important;
		}
	}
	.btntext6 {
		background-color: #a543b2;
		&:hover {
			background-color: #9633a2;
		}
		span {
			padding-top: 17px !important;
		}
	}
	.btn {
		width: 90px;
		height: 83px;
		margin-bottom: 1px;
		cursor: pointer;
		position: relative;
		text-align: center;
		span {
			color: #fff;
			font-size: 15px;
			height: 83px;
			display: block;
			padding: 0 5px;
			line-height: 18px;
		}
	}
}

@media screen and (max-width: 769px) {
	.mainbox {
		width: 100%;
		margin-top: 16px !important;
		.main_left {
			float: none;
			display: inline-block;
			width: 49%;
			margin-left: 0px !important;
			margin-bottom: 8px;
			&:nth-child(2n) {
				margin-left: 1% !important;
			}
			.main_img {
				a {
					img {
						width: 100%;
					}
				}
			}
			p {
				margin: 12px auto !important;
			}
		}
		.main_right {
			float: none;
			width: 100% !important;
			padding: 0 16px;
			margin-top: 16px;
			box-sizing: border-box;
			img {
				width: 100%;
			}
		}
	}
	// 中间骨架屏
	.skeleton-store-style {
		float: none !important;
		width: 100% !important;
		padding: 0 16px;
		div {
			width: 100% !important;
		}
	}
	.content_b {
		width: 100% !important;
		margin-top: 16px;
		.content2 {
			float: none !important;
			width: 100% !important;
			.content2_box {
				float: none !important;
				width: 100% !important;
				margin: 0px !important;
			}
		}
		.content2_right {
			float: none !important;
			width: 100% !important;
			.content2box {
				width: 100% !important;
				float: none !important;
				#divTrain {
					div {
						.name_nx {
							width: calc(100% - 100px);

							h3 {
								text-align: left !important;
							}
							a {
								text-align: left !important;
								overflow: hidden;
								text-overflow: ellipsis;
								display: -webkit-box;
								-webkit-line-clamp: 2;
								-webkit-box-orient: vertical;
							}
						}
					}
				}
				.content2box {
					margin: 0 auto;
					text-align: center;
					padding: 0 16px;
					a {
						width: 90% !important;
					}
					.content2_right_title {
						a {
							display: block;
							width: 24px !important;
							right: 6% !important;
						}
						img {
							width: 100% !important;
						}
					}
					.hot-news {
						.hotdot {
							width: 100%;
							.mj_gray {
								width: 100%;
								box-sizing: border-box;
								text-align: left;
								a {
									display: inline-block;
									width: 100%;
									overflow: hidden; //超出的文本隐藏
									text-overflow: ellipsis; //溢出用省略号显示
									white-space: nowrap; // 默认不换行；
								}
							}
						}
					}
				}
			}
		}
		.celibratebox {
			width: 100% !important;
			.celebrate {
				a {
					img {
						width: 100% !important;
					}
				}
			}
		}
		.bottom-column-item {
			margin: 0px !important;
			width: 100% !important;
		}
	}
}
.overflow-3-hidden {
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 4;
	-webkit-box-orient: vertical;
	word-break: break-all;
}

.middle-subject-space {
	width: 1100px;
	height: 91px;
	border: none;
	background-image: url(../assets/images/governmentMiddleBack.png);
	line-height: 91px;
	color: #fff8c6;
	font-weight: bold;
	font-size: 26px;
	text-align: center;
}
</style>
